import Big from 'big.js'

export default {

    calculate(maximumInsuredExposure, basisPoints, days, percentageOfExposure = 100) {
        // return zero if any variables are missing/falsey
        if (!maximumInsuredExposure || !basisPoints || !days || !percentageOfExposure) {
            return 0;
        }

        const basisPointsDecimal = new Big(basisPoints).div(10000);
        const daysDecimal = new Big(days).div(360);

        return new Big(maximumInsuredExposure).times(percentageOfExposure / 100)
                                        .times(basisPointsDecimal)
                                        .times(daysDecimal)
                                        .toFixed(2);
    },
};
